import React, { Component } from 'react';
// import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import Navigation from '../screens/Navigation.jsx';
import Headroom from "react-headroom";

import axios from 'axios';
import {
	isAuth,
	getCokie
} from '../helpers/auth';

export default class CreateNote extends Component {
	state = {
		mencion: this.props.match.params.mencion,
		ciclo: this.props.match.params.ciclo,
		year: this.props.match.params.year,
		showModal: false,
		fechaexa: new Date(),
		editing: false,
		zz: [],
		zzz: [],
		_id: '',
		files: '',
		ccss: [],
		ccs: [],
	};

	getNotes = async () => {
		const res = await axios.get(
			`${process.env.REACT_APP_API_URL}/users/stdaverages/` + this.props.match.params.mencion + `/` + this.props.match.params.ciclo + `/` + this.props.match.params.year
		);
		console.log(res.data);
		console.log("wwwwww");
		this.setState({
			zz: res.data,
		});
	};

	async componentDidMount() {
		this.getNotes();
	}

	onInputChange = e => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	};

	onChangeDate = fechaexa => {
		this.setState({ fechaexa });
	};


	deleteNote = async noteId => {
		const response = window.confirm('Deseas eliminar este capítulo?');
		if (response) {
			await axios.delete(`${process.env.REACT_APP_API_URL}/chapters/` + noteId);
			this.getNotes();
			toast.dark('Removido correctamente');
		}
	};


	fileSelectHandler = files => {
		var array = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'image/PNG'];
		// console.log(array.includes(files[0].type));
		if (files) {
			if (files[0].size < 1048576 && array.includes(files[0].type)) {
				this.setState({
					files,
				});
			} else {
				alert('Solo se acepta archivos no mayor a 1MB en formatos pdf, jpeg, jpg y png ');
			}
		}
	};

	// fileSelectHandlerww = (idsec, idchp) => {
	// 	// console.log(idsec);
	// 	this.setState({
	// 		section: idsec,
	// 		chapter: idchp,
	// 		task: true,
	// 		editing: false,
	// 		submit: 'Entregar tarea y seguir editando',
	// 	});
	// };

	// fileUploadHandler = async e => {
	// 	e.preventDefault();
	// 	//console.log(this.state.files[0]);
	// 	const data = new FormData();
	// 	data.append('archivo', this.state.files[0]);
	// 	data.append('idsec', this.state.section);
	// 	data.append('contenido', this.state.contenido);
	// 	data.append('chapter', this.state.chapter);
	// 	data.append('curse', getCokie('idc'));
	// 	data.append('user', isAuth()._id);
	// 	// console.log(data);

	// 	if (!this.state.editing) {
	// 		axios
	// 			.post(`${process.env.REACT_APP_API_URL}/tasks/`, data, {})
	// 			.then(res => {
	// 				// console.log(res);
	// 				this.getNotes();
	// 			})
	// 			.catch(err => console.log(err));
	// 		toast.dark('Tarea entregada correctamente');
	// 	} else {
	// 		await axios.put(`${process.env.REACT_APP_API_URL}/tasks/` + this.state._id, data);
	// 		this.getNotes();
	// 		toast.dark('Tarea actualizada correctamente');
	// 	}
	// 	this.closeTask();
	// 	this.setState({
	// 		id: '',
	// 		contenido: '',
	// 		files: '',
	// 	});
	// };

	submitTest = async e => {
		e.preventDefault();
		const Data = {
			preguntas: this.state.preguntas,
			respuestas: this.state.respuestas,
			foreign: this.state._id,
			user: isAuth()._id,
		};
		if (this.state.editing) {
			await axios.put(`${process.env.REACT_APP_API_URL}/tests/` + this.state._id, Data);
			this.getNotes();
			toast.success('Seccion actualizado correctamente');
		} else {
			// console.log(Data);
			await axios.post(`${process.env.REACT_APP_API_URL}/tests`, Data);
			this.getNotes();
		}
		this.setState({
			preguntas: '',
			respuestas: '',
			_id: '',
		});
	};
	render() {
		return (
			<div>
				<Headroom>
					<Navigation />
				</Headroom>
				<ToastContainer position="bottom-right" autoClose={2000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
				<div className="container my-3 text-center">
					<div className="row d-flex justify-content-center align-items-center p-0 m-0 border">
						{this.state.zz.map((note, index) => (
							<div className="col-md-6 p-1 m-0 text-center" key={index}>
								<div className="">
									{note._id}
									{note.email}
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		);
	}
}
